export const toggleswitch_configuration = {
  root: {
    padding: "0.5rem 1rem",
    gap: "0.25rem",
    borderRadius: "5px",
    background: "#fff",
  },

  jumpToPageInput: {
    maxWidth: "2.5rem",
  },

  colorScheme: {
    light: {
      background: "#FFFFFF",

      navButton: {
        background: "#fff",
        hoverBackground: "#fff",
        selectedBackground: "#fff",
        color: "#485464",
        width: "2rem",
        height: "2rem",
        borderRadius: "5px",
      },
      currentPageReport: {
        color: "{text.muted.color}",
      },
    },
    dark: {
      background: "#010622",
      navButton: {
        background: "#fff",
        hoverBackground: "#fff",
        selectedBackground: "#fff",
        color: "#1C3086",
        width: "2rem",
        height: "2rem",
        borderRadius: "5px",
      },
      currentPageReport: {
        color: "{text.muted.color}",
      },
    },
  },
};
